import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';

/** Leitura do cardápio antigo (`Cardapio/{grupo}/{subgrupo}`), usada só como fallback do modelo novo. */
@Injectable({ providedIn: 'root' })
export class CardapioLegadoFirebaseService {
  constructor(private afs: AngularFirestore) {}

  async getItens<T>(grupo: string, subgrupo: string): Promise<T[]> {
    const snapshot = await this.afs.firestore
      .collection('Cardapio')
      .doc(grupo.toLowerCase())
      .collection(subgrupo.toLowerCase())
      .get();
    return snapshot.docs.map(d => d.data() as T);
  }
}
